export default "__VITE_ASSET__CgctWEty__"